import React from 'react';
import { Box } from '@material-ui/core';
import LoadingIcon from 'components/CustomIcons/LoadingIcon';
import { useStyles } from './style';

function CircularLoading() {
  const classes = useStyles();
  return (
    <Box className={classes.circularLoading}>
      <LoadingIcon />
    </Box>
  );
}

export default CircularLoading;
